// This is for the production site, which is hosted at https://ngrx.io
export const environment = {
    gaId: 'UA-127598155-1', // Production id
    production: true,
    mode: 'stable',
};
